export default __webpack_public_path__ + "static/media/BearHeadColor.818006cc.png";